import Vue from 'vue';
import RouterLinkIgnoreDuplicate from '@/components/globals/RouterLinkIgnoreDuplicate.vue';
import BcContainer from './BcContainer.vue';

Vue.component('BcContainer', BcContainer);
Vue.component('RouterLinkIgnoreDuplicate', RouterLinkIgnoreDuplicate);
